import {
  createFieldbookSupabaseClient,
  setFieldbookSupabaseClient,
} from "@fieldbook/common/supabaseClient"
import { authStorage } from "@/platform"
import { fetchWithTimeout } from "./fetchWithTimeout"

// Bootstrap file: import this before any other @fieldbook/common module so
// shared relative imports of ../supabase use the mobile platform auth storage.
export const supabase = createFieldbookSupabaseClient({
  authStorage,
  fetch: fetchWithTimeout,
})
setFieldbookSupabaseClient(supabase)
